import { useState, type FC } from 'react'
import { Collapse } from '@mui/material'
import { Alert } from '@dhl-ui/components'
import { type MaintenanceMessageItem } from '../model/maintenance.js'

type Props = {
  item: MaintenanceMessageItem
  onDismiss?: (item: MaintenanceMessageItem) => void
}

export const MaintenanceAlert: FC<Props> = ({ item, onDismiss }) => {
  const [open, setOpen] = useState(true)

  const handleClose = () => {
    setOpen(false)
    onDismiss?.(item)
  }

  return (
    <Collapse in={open}>
      <Alert onClose={handleClose} title={item.title || undefined} severity="info">
        {item.body}
      </Alert>
    </Collapse>
  )
}
